import Scene from "~/scene";
import { store } from "~/state/store";
import { pointInPolygonTest } from "~/util/intersect";
import { CONFIG } from "~/config";
import { setOphotoDate } from "~/state/map/state";
import { frpc } from "./general";

const URL = "/ortophoto/date";
const FOR_ZOOM = 9;
const TIMEOUT = 500;
let testPolygon: Array<Array<number>> = [];
let timeout = 0;

function clear() {
	store.dispatch(setOphotoDate(""));
	testPolygon = [];
	clearTimeout(timeout);
	timeout = null;
}

export function checkOphotoDate(coords?: [number, number], zoom?: number) {
	if (!coords && !zoom) {
		clear();

		return;
	}

	if (zoom < FOR_ZOOM) {
		clear();

		return;
	}

	if (timeout) {
		clearTimeout(timeout);
		timeout = null;
	}

	if (!(testPolygon.length && pointInPolygonTest(coords, testPolygon))) {
		timeout = window.setTimeout(() => {
			// eslint-disable-next-line new-cap
			frpc({
				url: `${CONFIG.requestUrl}${URL}`,
				method: "getOrtophotoDate",
				args: [coords[0], coords[1]],
				hints: { 0: "float", 1: "float" },
			}).promise.then(data => {
				testPolygon = [];

				if (data.geom?.data?.length) {
					data.geom.data.forEach(polygon => {
						testPolygon.push(Scene.stringToCoords(polygon).map(item => item.toWGS84()));
					});
				}

				store.dispatch(setOphotoDate(data.date));
			}, () => {
				store.dispatch(setOphotoDate(""));
				clear();
			});
		}, TIMEOUT);
	}
}
